/**
 * PencilSharpenerIcon - a simple flat-illustration icon for a pencil sharpener.
 * There is no widely-supported emoji for a pencil sharpener, so this SVG keeps
 * the same friendly, colorful flat style as the other item icons (backpack,
 * pencil, ruler) used across the volunteer guide.
 */
export default function PencilSharpenerIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="Pencil sharpener"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Pencil going into the sharpener */}
      <g transform="rotate(-38 42 22)">
        {/* pencil body */}
        <rect x="34" y="15" width="26" height="9" rx="1.5" fill="#F4B740" />
        <rect x="34" y="15" width="26" height="3" rx="1.5" fill="#F9CE6B" />
        {/* eraser end */}
        <rect x="58.5" y="15" width="4" height="9" rx="1.5" fill="#EC6A5E" />
        {/* sharpened wood tip + lead */}
        <path d="M34 15 L26 19.5 L34 24 Z" fill="#E8C9A0" />
        <path d="M29.6 17.5 L26 19.5 L29.6 21.5 Z" fill="#2B2B2B" />
      </g>

      {/* Sharpener body (classic prism block) */}
      <rect x="12" y="30" width="30" height="22" rx="4" fill="#3E7CB1" />
      <rect x="12" y="30" width="30" height="7" rx="4" fill="#5B9BD1" />
      {/* metal blade plate */}
      <rect x="17" y="34" width="20" height="8" rx="1.5" fill="#C9D4DE" />
      <rect x="17" y="37" width="20" height="2.5" fill="#9AAAB8" />
      {/* insert hole */}
      <ellipse cx="27" cy="47" rx="5" ry="3" fill="#1F3A57" />

      {/* Shavings */}
      <path d="M44 47 q5 -4 9 -1 q-4 1 -5 4 q-3 -2 -4 -3 Z" fill="#E8C9A0" />
      <circle cx="52" cy="52" r="2.4" fill="#EFC46B" />
    </svg>
  );
}
